export function waitForRoot (callback) {
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.js-main-crust')
    callback(root)
  })
}
